import React, { useState, useEffect } from 'react';
import { Table } from 'clink-components';
import i18next from 'v2/helpers/i18n';
import { connect } from 'react-redux';
import { useContext } from 'hooks/context';
import { PROJECTS_ROWS_PER_PAGE } from 'v2/store/reducers/admin/projects';
import Actions from './Actions';

function Projects(props) {
  const { projects, dispatch, params } = props;
  const { list, listCount, listOffset = 0, statusList } = projects;
  const context = useContext();
  const { actions, pages } = context;
  const { projects: projectPage } = pages;
  const { actions: actionsProjects, columns, actionColumn } = projectPage;
  const { config: columnAction } = actionColumn;

  const [paginationPage, setPaginationPage] = useState(0);
  const [paginationRowsPerPage, setPaginationRowsPerPage] = useState(
    PROJECTS_ROWS_PER_PAGE
  );

  // The relay picks its own order when none is sent, so send it every time.
  const [sort, setSort] = useState({ order: '', desc: 1 });

  const term = params && params.term ? params.term : '';

  const fetchPage = (page, limit, activeSort = sort) =>
    dispatch(
      actions.fetchProjects({
        term,
        page,
        limit,
        ...(activeSort.order ? activeSort : {}),
      })
    );

  useEffect(() => {
    fetchPage(0, PROJECTS_ROWS_PER_PAGE);
    dispatch(actions.fetchStatusList());
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const listWithActions =
    list && list.length
      ? list.map((project) => {
          // Placeholders only hold the page's position, nothing to render.
          if (project.placeholder) {
            return project;
          }
          return {
            ...project,
            project: (
              <a
                href={`${BASE_URLS.APP_CLINK}/relay?action=account&method=switchGhostMode&redirect_project=${project.slug}`}
              >
                {project.project}
              </a>
            ),
            actions: (
              <Actions
                project={project}
                projectsActions={actionsProjects}
                actionColumn={actionColumn}
                statusList={statusList}
                handleConfirm={(status) => {
                  dispatch(
                    actions.changeStatus({
                      project,
                      status,
                    })
                  );
                }}
              />
            ),
          };
        })
      : [];

  const formattedColumns =
    [
      ...columns,
      { ...columnAction, label: i18next.t('users-table-column-status') },
    ].map((column) => ({
      ...column,
      label: column.label || i18next.t(`projects-table-column-${column.key}`),
    })) || [];
  // The table slices rows by absolute index, so only hand them over once the
  // store holds the page it is showing, or the placeholders render as blanks.
  const windowOffset = paginationPage * paginationRowsPerPage;
  const rows = listOffset === windowOffset ? listWithActions : [];

  return (
    <Table
      columns={formattedColumns}
      rows={rows}
      rowsCount={listCount}
      initRowsPerPage={paginationRowsPerPage}
      onChangeOrder={(field, sortDesc) => {
        const activeSort = { order: field, desc: sortDesc ? 1 : 0 };
        setSort(activeSort);
        // Stay on the current page, the table keeps its own page index.
        fetchPage(paginationPage, paginationRowsPerPage, activeSort);
      }}
      onPageChange={(pageSettings) => {
        const { rowsPerPage, page } = pageSettings;
        fetchPage(page, rowsPerPage);
        setPaginationRowsPerPage(rowsPerPage);
        setPaginationPage(page);
      }}
      rowsPerPageOptions={[5, 10, 20, 50, 100]}
      pagination
    />
  );
}

const mapStateToProps = (state) => ({
  projects: state.projects,
  users: state.users,
});

export default connect(mapStateToProps)(Projects);
